var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":_vm.title,"visible":this.visible,"custom-class":"se-help","size":"50%","direction":"rtl"},on:{"close":_vm.hide}},[_c('WebViewer',{attrs:{"url":"static/img/SoftwareLicenseAgreement.pdf"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }